import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistributionService {

  constructor(private http: HttpClient) { }

  getMyDoctorList(relativeMonth: string, refresh: boolean): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/my-doctor-list/${relativeMonth}/${refresh}`;
    return this.http.get(url);
  }

  getDoctorProfile(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/doctor-profile/${id}`;
    return this.http.get(url);
  }

  saveDoctorProfile(doctor: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/doctor-profile`;
    if (doctor.id) {
      return this.http.post(url, doctor);
    } else {
      return this.http.put(url, doctor);
    }
  }

  searchConsumers(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/search-consumer`;
    return this.http.post(url, value);
  }

  getMyStockiest(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/territory-stockiest`;
    return this.http.get(url);
  }

  enrollPatient(patientDetails: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/enroll-consumer`;
    return this.http.post(url, patientDetails);
  }

  getRegisteredConsumers(activeDoctorId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/consumers/${activeDoctorId}`;
    return this.http.get(url);
  }

  getListedTransplantPatients(doctorId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/listed-transplant-patients/${doctorId}`;
    return this.http.get(url);
  }

  getTransplantCases(doctorId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/doctor-transplant-cases/${doctorId}`;
    return this.http.get(url);
  }

  saveTransplantCase(transplantCase: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/transplant-cases`;
    return this.http.put(url, transplantCase);
  }

  getMyTerritoryList(relativeMonth: any, refresh: boolean): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/my-territory-list/${relativeMonth}/${refresh}`;
    return this.http.get(url);
  }

  getHospitalInfo(hospitalId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/hospital/${hospitalId}`;
    return this.http.get(url);
  }

  saveHospitalInfo(hospital: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/hospital`;
    if (hospital.id) {
      return this.http.post(url, hospital);
    } else {
      return this.http.put(url, hospital);
    }
  }

  getMyHospitals(): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/my-hospitals`;
    return this.http.get(url);
  }

  saveTransplantCases(doctorId: string, value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/doctor-transplant-cases/${doctorId}`;
    return this.http.post(url, value);
  }

  deleteTransplantCases(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/doctor-transplant-cases/${id}`;
    return this.http.delete(url);
  }
}
